import React, {useEffect, useState} from "react";
import api from "../api";


const Terms = () => {
    const [termsText, setTermsText] = useState('');

    useEffect(() => {
        const fetchPolicies = async () => {
            try {
                const privacyResp = await api.get('/terms');
                setTermsText(privacyResp.data);

            } catch (error) {
                console.error('Failed to load Terms and Conditions', error);
            }
        };
        fetchPolicies();
    }, []);


    return (

        <div className="item-detail">
            <h2>Privacy Policy</h2>
            <p>
                {termsText}
            </p>
        </div>

    )

}

export default Terms;